import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';
import { SolicitudesVacacionesPorComunicarTH, PostFirmaMasivo } from './TypesComunicadoSolicitudesV';
import TablaComunicadoSolicitudesV from './TablaComunicadoVacaciones';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"
import { ObtenerInformacionComunicados, VistaPreviaSolicitudVacaciones, ComunicarSolicitudVacaciones, FirmaMasivaAccionPersonal, AnularAccionPersonalVacacion } from './FunctionComunicadoSolicitudesV';

type StateComunicadoSolicitudes = {
    filasTabla: SolicitudesVacacionesPorComunicarTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionComunicarVacaciones = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalAprobacionMasicaAccionPersonal = {
    cargando: boolean,
    modalContent: HTMLElement | undefined,
    filasTabla: SolicitudesVacacionesPorComunicarTH[]
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export function showAlertSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        text: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertHTMLSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        html: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertSwalAnuncio(message: string) {
    Swal.fire({
        text: message,
        imageUrl: `${AnuncioSVG}`,
        imageHeight: 100, // Ajusta el tamaño según sea necesario
        imageAlt: "Anuncio",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export default function ComunicadoSolicitudesV() {
    const TITULO_COMUNICADO_SOLICITUDES = "NOTIFICACIÓN AL SERVIDOR PUBLICO DE LA AP DE VACACIONES/REINTEGRO";

    const defaulState: StateComunicadoSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalComunicarVacaciones: StateModalInformacionComunicarVacaciones = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        tituloModal: "Registro y Control de Solicitud de Vacaciones"
    }

    const defaultSateModalAprobacionMasivaAccionPersonal: StateModalAprobacionMasicaAccionPersonal = {
        cargando: false,
        modalContent: undefined,
        filasTabla: []
    }

    const defaultStateModalInformacionAnular: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        observacion: ""
    }

    const [stateComunicado, setstateComunicado] = useState<StateComunicadoSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [stateinformacionModalComunicarAP, setstateinformacionModalComunicarAP] = useState(defaultStateModalComunicarVacaciones)
    const [stateModalAprobacionMasivaAccionPersonal, setstateModalAprobacionMasivaAccionPersonal] = useState(defaultSateModalAprobacionMasivaAccionPersonal)
    const [stateinformacionModalAnular, setstateinformacionModalAnular] = useState(defaultStateModalInformacionAnular)

    const [observacion, setobservacion] = useState("");

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosComunicados() {
        setstateComunicado({ ...stateComunicado, loadingFilas: true })
        const resultado = await ObtenerInformacionComunicados()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateComunicado({ ...stateComunicado, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateComunicado({ ...stateComunicado, filasTabla: resultado.dataResponse, loadingFilas: false })
            }
        } else {
            setstateComunicado(prev => ({ ...prev, mensajeError: resultado.errorMessage, loadingFilas: false, errorFilas: true }));

        }
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosComunicados();
    }, [])

    async function OnCloseModalAnulacion() {
        await ObtenerDatosComunicados()
        setstateinformacionModalAnular(defaultStateModalInformacionAnular)
        ScrollToTop();
    }

    async function OnCloseModalComunicado() {
        setstateinformacionModalComunicarAP(defaultStateModalComunicarVacaciones)
        await ObtenerDatosComunicados()
        ScrollToTop();
    }

    function onClickAprobacionMasiva(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalSolicitudes(informacionAcciones)
        setstateModalAprobacionMasivaAccionPersonal({
            cargando: false,
            filasTabla: informacionAcciones,
            modalContent
        })
    }

    function AuxiliarGenerarHTMLBodyModalSolicitudes(informacionAcciones): any {
        return (
            <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Tipo Solicitud</th>
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        {informacionAcciones.map((solicitudes, ind) => {

                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {solicitudes.tipoSolicitud}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaSolicitud)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.nombres}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaInicio)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaFin)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.tiempo}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.estadoParse}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </>
        )
    }

    const tablaComunicados = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla, mensajeError } = stateComunicado
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        } else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaComunicadoSolicitudesV
                    dataFilas={stateComunicado.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickComunicar={(solicitud: any) => onClickAprobarParcialmenteSolicitudVacaciones(solicitud)}
                    onClickNotificacionMasiva={async (solicitudes: SolicitudesVacacionesPorComunicarTH[]) => await onClickAprobacionMasiva(solicitudes)}
                    onClickRechazar={(solicitud: any) => onClickAnularAccionPersonal(solicitud)}
                />
            )
        }
        else {
            return (
                <TablaComunicadoSolicitudesV
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => { ; }}
                    onClickComunicar={(solicitud: any) => { ; }}
                    onClickNotificacionMasiva={async (solicitudes: SolicitudesVacacionesPorComunicarTH[]) => { ; }}
                    onClickRechazar={(solicitud: any) => { ; }}
                />
            )
        }
    }, [stateComunicado])

    function AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones): any {
        return (
            <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Tipo Solicitud</th>
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tipoSolicitud}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </>
        )
    }

    function onClickAnularAccionPersonal(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones);

        setstateinformacionModalAnular({
            cargando: false,
            idSolicitud: informacionAcciones.idSolicitudVacacion,
            tipoSolicitud: informacionAcciones.tipoSolicitud,
            modalContent,
            observacion
        })
    }

    async function AnularAP(idSolicitud, observacion, tipoSolicitud) {
        const respuesta = await AnularAccionPersonalVacacion(idSolicitud, observacion, tipoSolicitud)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            return 1;
        }
        else {
            await showAlert("Se ha anulado la acción de personal", ExitoSVG, true);
            return -1
        }
    }

    async function onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones) {       
        var titulo = "";
        var respuestaSolicitud: ResponseRequest = { status: -1 };
        respuestaSolicitud = await VistaPreviaSolicitudVacaciones(informacionAcciones.idSolicitudVacacion, informacionAcciones.tipoSolicitud);
        if (respuestaSolicitud.status === 200) {
            var content: any = undefined;
            if (informacionAcciones.tipoSolicitud == "Reintegro Vacación") {
                titulo = "Acción de Personal de Reintegro"
                setstateinformacionModalComunicarAP({
                    url: respuestaSolicitud.dataResponse,
                    cargando: false,
                    tituloModal: titulo,
                    modalContent: content,
                    idSolicitud: informacionAcciones.idSolicitudVacacion,
                    tipoSolicitud: informacionAcciones.tipoSolicitud
                })
            } else {
                titulo = "Acción de Personal de Vacaciones"
                setstateinformacionModalComunicarAP({
                    url: respuestaSolicitud.dataResponse,
                    cargando: false,
                    tituloModal: titulo,
                    modalContent: content,
                    idSolicitud: informacionAcciones.idSolicitudVacacion,
                    tipoSolicitud: informacionAcciones.tipoSolicitud
                })
            }
        }
        else {
            alertService.error(respuestaSolicitud.errorMessage ?? "");
        }
    }

    async function OnClickAccionModalFormulario(idSolicitud, tipoSolicitud) {
        setstateinformacionModalComunicarAP({ ...defaultStateModalComunicarVacaciones, cargando: true })
        var accionRealizada = await ComunicarSolicitudVacaciones(idSolicitud, tipoSolicitud)
        setstateinformacionModalComunicarAP(defaultStateModalComunicarVacaciones)
        await ObtenerDatosComunicados();
    }

    async function OnCloseModalAprobacionMasiva() {
        setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)
        await ObtenerDatosComunicados();
    }

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_COMUNICADO_SOLICITUDES} </div>
            {tablaComunicados}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de vacaciones/reintegro'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalConfirmacion
                show={stateinformacionModalComunicarAP.idSolicitud > 0 || stateinformacionModalComunicarAP.cargando}
                size="lg"
                onClose={() => setstateinformacionModalComunicarAP(defaultStateModalComunicarVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea notificar la solicitud de vacaciones/reintegro?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => ComunicarSolicitudVacaciones(stateinformacionModalComunicarAP.idSolicitud, stateinformacionModalComunicarAP.tipoSolicitud)}
                contentModal={stateinformacionModalComunicarAP.modalContent}
                tituloModal={stateinformacionModalComunicarAP.tituloModal}
                asyncAfterOnClose={() => OnCloseModalComunicado()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}
            />

            <ModalConfirmacion
                show={stateModalAprobacionMasivaAccionPersonal.filasTabla.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea notificar las siguientes Acciones de Personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => FirmaMasivaAccionPersonal(stateModalAprobacionMasivaAccionPersonal.filasTabla)}
                contentModal={stateModalAprobacionMasivaAccionPersonal.modalContent}
                tituloModal={"Notificación masiva de Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAprobacionMasiva()}
                botonesAccionParteSuperior={true}
            />

            <ModalRechazo
                show={stateinformacionModalAnular.idSolicitud > 0 || stateinformacionModalAnular.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAnular(defaultStateModalInformacionAnular)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea anular la acción de personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => AnularAP(stateinformacionModalAnular.idSolicitud, { Observacion: observacion }, stateinformacionModalAnular.tipoSolicitud)}
                contentModal={stateinformacionModalAnular.modalContent}
                tituloModal={"Anular Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAnulacion()}
                labelObservacion={"Indique el motivo de anulación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />

            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalComunicarAP.url !== "" || stateinformacionModalComunicarAP.cargando}
                onClose={() => setstateinformacionModalComunicarAP(defaultStateModalComunicarVacaciones)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalComunicarAP.cargando}
                size="xl"
                tituloModal={stateinformacionModalComunicarAP.tituloModal}
                urlArchivo={stateinformacionModalComunicarAP.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalComunicarAP.idSolicitud, stateinformacionModalComunicarAP.tipoSolicitud)}
                disabledbuttonCondition={stateinformacionModalComunicarAP.cargando}
                modalContent={stateinformacionModalComunicarAP.modalContent}
            />
        </div>
    )
}